import React from 'react';
import { BasicImageRendererFactory } from 'app/interfaces/ImageRenderer';

const thumbnailImageRendererFactoryContext =
  React.createContext<BasicImageRendererFactory>(undefined);

export default thumbnailImageRendererFactoryContext;
